<div class="footer-container">

  <div class="mobile-apps" nz-row nzJustify="space-between">
    <a href="https://apps.apple.com/kz/app/starbusiness/id1452748006" target="_blank">
      <img src="../../../assets/icons/appstore.svg">
    </a>
    <a href="https://play.google.com/store/apps/details?id=bcc.sapphire" target="_blank">
      <img src="../../../assets/icons/googleplay.svg">
    </a>
  </div>

  <div class="footer bg-main text-light" nz-row nzAlign="middle">
    <div class="footer__bank-name" [translate]="'HOME.FOOTER.COPYRIGHT'">
      © 2000-{{currentYear}} АО «Банк ЦентрКредит»
    </div>
    <div class="footer__contacts " nz-row nzJustify="space-between">
      <a target="_blank" href="https://wa.me/77471111605">
        <p><img src="../../../assets/icons/whatsapp.svg" class="whatIcon"> +7 (747) 111-16-05</p>
      </a>
      <a href="tel:605">
        <p><img src="assets/icons/mobile.svg" /> 605</p>
      </a>
    </div>
  </div>
</div>
